<section [ngClass]="mainClass">
  <head>
    <h3 translate>{{ headLabel }}</h3>

    @if (!valid) {
      <button type="button" (click)="onButtonClick()" class="button" translate>
        session-retake-request-form-item.component.retake-button
      </button>
    }
  </head>

  <div class="photo-wrapper">
    @if (photo()) {
      <img [src]="photoURL()" />
    } @else {
      <img [src]="currentPhotoUrl" />

      <div class="photo-overlay">
        <p translate>session-retake-request-form-item.component.retake-info</p>
      </div>
    }
  </div>

  <footer>
    <i [lvIcon]="valid ? 'check' : 'times'"></i>
    <pre>{{ reason }}</pre>
  </footer>
</section>
